import { render, staticRenderFns } from "./bene.vue?vue&type=template&id=36e7e7ec&scoped=true"
import script from "./bene.vue?vue&type=script&lang=js"
export * from "./bene.vue?vue&type=script&lang=js"
import style0 from "./bene.vue?vue&type=style&index=0&id=36e7e7ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e7e7ec",
  null
  
)

export default component.exports